import { create } from 'zustand';
import type { KanbanRoom } from '../types';

interface KanbanBoardStore {
  roomInfo: KanbanRoom | null;
  activeBoardId: string | null;
  setRoomInfo: (room: KanbanRoom) => void;
  setActiveBoardId: (boardId: string | null) => void;
  resetStore: () => void;
}

export const useKanbanBoardStore = create<KanbanBoardStore>((set) => ({
  roomInfo: null,
  activeBoardId: null,

  setRoomInfo: (room) => set({ roomInfo: room }),

  setActiveBoardId: (boardId) => set({ activeBoardId: boardId }),

  resetStore: () =>
    set({
      roomInfo: null,
      activeBoardId: null,
    }),
}));
